import { Directive, ElementRef, OnInit, Input, Injector, Renderer2, inject } from '@angular/core';
import { FormGroupDirective, ControlContainer, FormControl, FormGroup, FormArray } from '@angular/forms';

@Directive({ selector: '[appFormControlValidityClass]' })
export class FormControlValidityClassDirective implements OnInit {
  private element = inject(ElementRef);
  private renderer = inject(Renderer2);
  private injector = inject(Injector);
  private parentContainer = inject(ControlContainer, { host: true, skipSelf: true });

  @Input() formControlName = null;

  formGroupDirective: FormGroupDirective;
  formControl: FormControl;

  ngOnInit() {
    this.formGroupDirective = this.injector.get(FormGroupDirective, null);

    const parentControl = this.parentContainer.control as FormGroup | FormArray;
    this.formControl = parentControl.controls[this.formControlName];

    this.formGroupDirective.form.statusChanges.subscribe(() => this.update());
    this.formGroupDirective.ngSubmit.subscribe(() => this.update());
  }

  private update() {
    if (this.isControlInvalid()) {
      this.renderer.addClass(this.element.nativeElement, 'is-invalid');
    } else {
      this.renderer.removeClass(this.element.nativeElement, 'is-invalid');
    }
  }

  private isControlInvalid(): boolean {
    if (this.formGroupDirective && this.formGroupDirective.submitted) {
      return this.formControl && this.formControl.invalid;
    } {
      return false;
    }
  }
}
